"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    ActionPanelGroupVariants: ()=>ActionPanelGroupVariants,
    ActionPanelVariants: ()=>ActionPanelVariants
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const index_cjs_namespaceObject = require("../Toggle/index.cjs");
const BASE_TRANSITION = 'transition duration-300';
const ActionPanelGroupVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        baseSlot: ''
    },
    variants: {},
    compoundVariants: [],
    defaultVariants: {}
});
const { root: switchRoot, slider: switchSlider } = (0, index_cjs_namespaceObject.toggleVariants)({
    size: '20',
    emphasis: 'regular'
});
const ActionPanelVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        baseSlot: [
            "bg-primary-1",
            "border-neutral-4",
            "group",
            "flex",
            "cursor-pointer",
            "flex-col",
            "rounded-xl",
            "border",
            BASE_TRANSITION,
            "outline-primary-8",
            "not-last:mb-4",
            "active:bg-primary-4",
            'has-[button[role="checkbox"][data-checked]]:hover:bg-primary-4',
            "has-[button[data-disabled]]:hover:bg-primary-1",
            "has-[button[data-disabled]]:active:bg-primary-1",
            "has-[button[data-checked]]:bg-primary-3",
            "has-[button[data-checked][data-disabled]]:bg-neutral-2/60",
            "has-[button[data-checked][data-disabled]]:hover:bg-neutral-2/60",
            "has-[button[data-disabled]]:cursor-not-allowed",
            'has-[button[role="radio"][data-checked]]:cursor-default',
            "has-[button[data-checked]]:border-transparent",
            "has-[button:focus-visible]:outline-2",
            "has-[button:focus-visible]:outline-offset-2"
        ],
        titleSlot: 'flex items-center gap-4 p-4 group-has-[button[data-disabled]]:[&>div[data-testid="action-panel-title-content"]]:opacity-25',
        titleContentSlot: '',
        contentSlot: [
            BASE_TRANSITION,
            "max-h-0",
            "overflow-hidden",
            "opacity-0",
            "transition-[max-height,height,opacity]",
            "group-has-[button[data-checked]]:max-h-[attr(data-children-height_px)]",
            "group-has-[button[data-checked]]:opacity-100"
        ],
        radioRootSlot: "hover:data-checked:bg-primary-8 hover:data-checked:border-primary-8 data-disabled:hover:shadow-none min-h-4 min-w-4 focus-visible:outline-none",
        switchRootSlot: switchRoot({
            class: 'ml-auto hover:drop-shadow-none focus-visible:outline-none'
        }),
        switchIndicatorSlot: switchSlider(),
        buttonSlot: [
            "data-disabled:group-hover:cursor-not-allowed",
            "data-checked:group-hover:cursor-not-allowed",
            "[[data-unchecked]:not([data-disabled])]:[&_div[data-input-unchecked]:not([data-input-disabled])]:flex",
            "[[data-unchecked]:not([data-disabled])]:[&_div[data-input-unchecked][data-input-disabled]]:hidden",
            "[[data-unchecked]:not([data-disabled])]:[&_div[data-input-checked]:not([data-input-disabled])]:hidden",
            "[[data-unchecked]:not([data-disabled])]:[&_div[data-input-checked][data-input-disabled]]:hidden",
            "[[data-unchecked][data-disabled]]:[&_div[data-input-unchecked]:not([data-input-disabled])]:hidden",
            "[[data-unchecked][data-disabled]]:[&_div[data-input-unchecked][data-input-disabled]]:flex",
            "[[data-unchecked][data-disabled]]:[&_div[data-input-checked]:not([data-input-disabled])]:hidden",
            "[[data-unchecked][data-disabled]]:[&_div[data-input-checked][data-input-disabled]]:hidden",
            "[[data-checked]:not([data-disabled])]:[&_div[data-input-unchecked]:not([data-input-disabled])]:hidden",
            "[[data-checked]:not([data-disabled])]:[&_div[data-input-unchecked][data-input-disabled]]:hidden",
            "[[data-checked]:not([data-disabled])]:[&_div[data-input-checked]:not([data-input-disabled])]:flex",
            "[[data-checked]:not([data-disabled])]:[&_div[data-input-checked][data-input-disabled]]:hidden",
            "[[data-checked][data-disabled]]:[&_div[data-input-unchecked]:not([data-input-disabled])]:hidden",
            "[[data-checked][data-disabled]]:[&_div[data-input-unchecked][data-input-disabled]]:hidden",
            "[[data-checked][data-disabled]]:[&_div[data-input-checked]:not([data-input-disabled])]:hidden",
            "[[data-checked][data-disabled]]:[&_div[data-input-checked][data-input-disabled]]:flex",
            "flex",
            "justify-center",
            "pb-4",
            "*:w-[160px]",
            "focus-within:outline-none",
            "focus-visible:outline-none",
            "*:focus-visible:ring-0",
            "group-hover:cursor-pointer"
        ]
    },
    variants: {
        elevated: {
            true: {
                baseSlot: [
                    "has-[button[data-disabled]]:bg-neutral-2",
                    "has-[button[data-disabled]]:hover:bg-neutral-2",
                    "has-[button[data-disabled]]:active:bg-neutral-2",
                    "border-none",
                    "shadow-md",
                    "transition-[background-color,box-shadow]",
                    "hover:shadow-xl",
                    "has-[button[data-checked]]:shadow-none",
                    "has-[button[data-disabled]]:shadow-none",
                    "has-[button[data-disabled]]:hover:shadow-none"
                ]
            },
            false: {
                baseSlot: 'hover:bg-primary-3'
            }
        }
    },
    compoundVariants: [],
    defaultVariants: {
        elevated: false
    }
});
exports.ActionPanelGroupVariants = __webpack_exports__.ActionPanelGroupVariants;
exports.ActionPanelVariants = __webpack_exports__.ActionPanelVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "ActionPanelGroupVariants",
    "ActionPanelVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
